import { render, staticRenderFns } from "./UiSidepage.vue?vue&type=template&id=c4fdd19c&"
import script from "./UiSidepage.vue?vue&type=script&lang=js&"
export * from "./UiSidepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports